import { createRouter, createWebHistory } from "vue-router";

import DetailPage from "../views/DetailPage.vue";
import MasterPage from "../views/MasterPage.vue";
import SDGPage from "../views/SDGPage.vue";
import ErrorPage from "../views/ErrorPage.vue";

const routes = [
  {
    path: "/",
    name: "MasterPage",
    component: MasterPage,
    props: true,
  },
  {
    path: "/plan/:id(\\d+)",
    name: "DetailPage",
    component: DetailPage,
  },
  {
    // 修改成更明確的匹配規則
    path: "/index.html",
    redirect: { name: "MasterPage" }, // 使用具名路由重定向
  },
  {
    path: "/sdg",
    name: "SDGPage",
    component: SDGPage,
  },
  {
    path: "/error",
    name: "ErrorPage",
    component: ErrorPage,
  },
  {
    path: "/:catchAll(.*)",
    redirect: "/error",
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
